export default "__VITE_ASSET__WA5QVSFz__"